import {menuAnatomy as parts} from '@chakra-ui/anatomy';
import {createMultiStyleConfigHelpers, cssVar, defineStyle} from '@chakra-ui/styled-system';

const {defineMultiStyleConfig, definePartsStyle} = createMultiStyleConfigHelpers(parts.keys);

const $bg = cssVar(`menu-bg`);
const $shadow = cssVar(`menu-shadow`);

const baseStyleList = defineStyle({
  [$bg.variable]: `#fff`,
  [$shadow.variable]: `shadows.sm`,
  _dark: {
    [$bg.variable]: `colors.gray.700`,
    [$shadow.variable]: `shadows.dark-lg`,
  },
  color: `inherit`,
  minW: `3xs`,
  py: `2`,
  zIndex: `dropdown`,
  borderRadius: `md`,
  borderWidth: `1px`,
  bg: $bg.reference,
  boxShadow: $shadow.reference,
});

const baseStyleItem = defineStyle({
  py: `8`,
  px: `12`,
  _focus: {
    _dark: {},
  },
  _active: {
    _dark: {},
  },
  _expanded: {
    _dark: {},
  },
  _disabled: {},
});

const baseStyleGroupTitle = defineStyle({});

const baseStyleIcon = defineStyle({});

const baseStyleCommand = defineStyle({});

const baseStyleDivider = defineStyle({});

const baseStyleButton = defineStyle({});

const baseStyle = definePartsStyle({
  button: baseStyleButton,
  list: baseStyleList,
  item: baseStyleItem,
  groupTitle: baseStyleGroupTitle,
  icon: baseStyleIcon,
  command: baseStyleCommand,
  divider: baseStyleDivider,
});

const MenuTheme = defineMultiStyleConfig({
  baseStyle,
});

export default MenuTheme;
